"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findAttributeDependencies = findAttributeDependencies;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _productRulesEngine = require("@cimpress-technology/product-rules-engine");

var _mathEvaluationHelper = require("@cimpress-technology/math-evaluation-helper");

function getUniqueValues(arr) {
  return arr.filter(function (value, index, self) {
    return self.indexOf(value) === index;
  });
}

function areKeysEqual(key1, key2) {
  return key1.toLowerCase() === key2.toLowerCase();
}
/**
 * Find dependencies based on attributes containered in the whiteList
 * @param attribute - The attribute to search for
 * @param whiteList - The white list to pull the attribute definitions from
 * @return Array of dependencies for the given attribute based on the given white list
 */


function findAttributeDependenciesInWhiteList(attribute, whiteList) {
  var attributeDependencies = [];
  whiteList.forEach(function (whiteListAttribute) {
    if (whiteListAttribute.attributeValueTranslations) {
      var containeredAttributes = whiteListAttribute.attributeValueTranslations.some(function (translation) {
        return translation.attributeSelections.find(function (selection) {
          return areKeysEqual(selection.attributeKey, attribute);
        });
      });

      if (containeredAttributes && !attributeDependencies.includes(whiteListAttribute.attributeKey)) {
        attributeDependencies.push(whiteListAttribute.attributeKey);
      }
    }
  });
  return attributeDependencies;
}
/**
 * Find rules that determine the value for the given attribute and return a list of predicate
 * attributes from those rules.
 * @param attribute - The attribute to search for
 * @param rules - The rules to search within
 * @return Array of dependencies for the given attribute based on the given rules
 */


function findAttributeDependenciesInRules(attribute, rules) {
  var attributeDependencies = [];
  rules.forEach(function (rule) {
    if (rule.results.find(function (ruleAttribute) {
      return areKeysEqual(ruleAttribute.attributeKey, attribute);
    })) {
      var predicateAttributes = rule.predicates.map(function (ruleAttribute) {
        return ruleAttribute.attributeKey;
      });
      attributeDependencies.push.apply(attributeDependencies, (0, _toConsumableArray2.default)(predicateAttributes));
    }
  });
  return attributeDependencies;
}
/**
 * If the give attribute is a formula find the attributes that determine the value for a formula attribute.
 * @param attributeKey - The attribute to check against
 * @param whiteList - The white list to pull the attribute definitions from
 * @return Array of dependencies for the given attribute if it's a formula
 */


function findFormulaAttributeDependencies(attributeKey, whiteList) {
  var formulaDependencies = [];
  var attribute = whiteList.find(function (whiteListAttribute) {
    return areKeysEqual(whiteListAttribute.attributeKey, attributeKey);
  });

  if (attribute !== undefined && attribute.type === _productRulesEngine.AttributeTypes.formula) {
    var formulaVariables = attribute.formula.match(_mathEvaluationHelper.constants.VARIABLE_TOKEN_REGEX);

    if (formulaVariables !== null) {
      var attributeKeys = formulaVariables.map(function (match) {
        return match.replace(_mathEvaluationHelper.constants.VARIABLE_TOKEN_REPLACE_REGEX, '');
      });
      formulaDependencies.push.apply(formulaDependencies, (0, _toConsumableArray2.default)(attributeKeys));
    }
  }

  return formulaDependencies;
}
/**
 * Find all dependencies for a given attribute
 * @param attribute - The attribute to find dependencies for
 * @param ruleSet - The ruleSet to search within.
 * @return Array of dependencies need to calculate the given attribute, including the
 *  attribute itself
 */


function findAttributeDependencies(attribute, ruleSet) {
  var attributeDependencies = [];
  var dependencyStack = [attribute];

  var _loop = function _loop() {
    var currentAttribute = dependencyStack.pop();
    attributeDependencies.push(currentAttribute);
    var newDependencies = []; // find dependencies based on rules
    // (Only do this for derived attributes. For non-derived attributes this brings in unnecessary dependencies)

    var whiteListAttribute = ruleSet.whiteList.find(function (att) {
      return areKeysEqual(att.attributeKey, currentAttribute);
    });

    if (whiteListAttribute !== undefined && whiteListAttribute.derived) {
      newDependencies.push.apply(newDependencies, (0, _toConsumableArray2.default)(findAttributeDependenciesInRules(currentAttribute, ruleSet.rules)));
    } // find dependencies based on containered attributes in the whiteList


    newDependencies.push.apply(newDependencies, (0, _toConsumableArray2.default)(findAttributeDependenciesInWhiteList(currentAttribute, ruleSet.whiteList))); // Pull dependencies from formulae

    newDependencies.push.apply(newDependencies, (0, _toConsumableArray2.default)(findFormulaAttributeDependencies(currentAttribute, ruleSet.whiteList)));
    dependencyStack = getUniqueValues(dependencyStack.concat(newDependencies));
    dependencyStack = dependencyStack.filter(function (dependency) {
      return !attributeDependencies.includes(dependency);
    });
  };

  while (dependencyStack.length > 0) {
    _loop();
  }

  return attributeDependencies;
}